// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__28Lq2","header":"ReportDetails_header__37emm","title":"ReportDetails_title__t9mVM","left":"ReportDetails_left__2OCB9"};